export const FORM_EVENTS = {
  contactSubmitted: 'form_contact_submitted',
  contactFailed: 'form_contact_failed',
  newsletterSubmitted: 'form_newsletter_submitted',
  newsletterFailed: 'form_newsletter_failed',
  supportTicketCreated: 'form_support_ticket_created',
  supportReplySent: 'form_support_reply_sent',
  supportCategorySelected: 'form_support_category_selected',
} as const;

export type FormEventNameType = (typeof FORM_EVENTS)[keyof typeof FORM_EVENTS];
